import { influencerActionsEnum } from "@entities/brief/lib/constants";
import { NegotiateInfluencerCommercialsPopover } from "@features/briefInfluencerCommercials/negotiateInfluencerCommercials/NegotiateInfluencerCommercialsPopover";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { Popover } from "@shared/ui";
import { Button, Dropdown, Menu } from "antd";
import { Ellipsis } from "lucide-react";
import React, { useState } from "react";
import { InfluencerCommercial } from "../InfluencerCommercialsCost/InfluencerCommercial";
import styles from "./styles.module.scss";
// import { AskInfluencerCommercials } from "../askInfluencerCommercials/AskInfluencerCommercials";
// import { NegotiateInfluencerCommercials } from "../negotiateInfluencerCommercials/NegotiateInfluencerCommercials";

interface Props {
  briefInfluencer: IBriefInfluencerV2;
  actions: influencerActionsEnum[];
  isHovered?: boolean;
  onDropdownOpenChange?: (open: boolean) => void;
}

export default function InflunencerCommercialsDropDown({
  briefInfluencer,
  actions,
  isHovered = false,
  onDropdownOpenChange,
}: Props) {
  const [modal, setModal] = useState<null | "add" | "add-new" | "view" | null>(
    null
  );

  const [isCommercialsRequestedModal, setIsCommercialsRequestedModal] =
    useState(false);

  const [isNegotiateModal, setIsNegotiateModal] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  React.useEffect(() => {
    if (onDropdownOpenChange) {
      onDropdownOpenChange(
        modal !== null ||
          isCommercialsRequestedModal ||
          isNegotiateModal ||
          dropdownOpen
      );
    }
  }, [
    modal,
    isCommercialsRequestedModal,
    isNegotiateModal,
    dropdownOpen,
    onDropdownOpenChange,
  ]);

  const handleMenuClick = ({ key }: { key: string }) => {
    if (key === influencerActionsEnum.addInfluencerCommercial) {
      setModal("add");
    } else if (key === influencerActionsEnum.addNewInfluencerCommercial) {
      setModal("add-new");
    } else if (key === influencerActionsEnum.negotiate) {
      setDropdownOpen(false);
      setIsNegotiateModal(true);
    } else if (key === influencerActionsEnum.viewInfluencerCommercial) {
      setModal("view");
    } else if (key === influencerActionsEnum.resend) {
      setIsCommercialsRequestedModal(true);
    }
  };

  const handleCloseModal = () => {
    setModal(null);
  };

  const getModalType = () => {
    switch (modal) {
      case "add":
        return "create";
      case "add-new":
        return "create-new";
      case "view":
        return "view";
      default:
        return "create";
    }
  };

  const menu = (
    <Menu
      onClick={(e) => {
        e.domEvent.stopPropagation();
        handleMenuClick({ key: e.key });
      }}
    >
      {actions
        .filter((action) => action !== influencerActionsEnum.resend)
        .map((action) => (
          <Menu.Item key={action}>{action}</Menu.Item>
        ))}
    </Menu>
  );

  return (
    <>
      <NegotiateInfluencerCommercialsPopover
        open={isNegotiateModal}
        briefInfluencer={briefInfluencer}
        onOpenChange={setIsNegotiateModal}
      >
        <Popover
        open={modal !== null}
        className={styles.popover}
        trigger={["click"]}
        style={{width: 200}}
        title={
          modal === "add"
            ? "Add Influencer Commercial"
            : modal === "add-new"
              ? "Add New Influencer Commercial"
              : "View Commercial"
        }
        content={
          modal !== null ? (
            <InfluencerCommercial
              onClose={handleCloseModal}
              briefInfluencer={briefInfluencer}
              type={getModalType()}
            />
          ) : null
        }
        onOpenChange={(open) => {
          if (!open) {
            handleCloseModal();
          }
        }}
        destroyTooltipOnHide
      >
        <Dropdown
          overlay={menu}
          trigger={["click"]}
          placement="bottomRight"
          open={dropdownOpen}
          onOpenChange={setDropdownOpen}
        >
          {isHovered ? (
            <Button
              icon={<Ellipsis size={14} />}
              type="text"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          ) : null}
        </Dropdown>
        </Popover>
      </NegotiateInfluencerCommercialsPopover>

      {/* <Popover
        open={isNegotiateModal}
        className={styles.popover}
        title={"Negotiate Commercial"}
        content={
          <NegotiateInfluencerCommercials
            briefInfluencer={briefInfluencer}
            onClose={() => setIsNegotiateModal(false)}
          />
        }
        onOpenChange={(open) => setIsNegotiateModal(open)}
        destroyTooltipOnHide
      /> */}
      {/* <Modal
        open={isCommercialsRequestedModal}
        onCancel={() => setIsCommercialsRequestedModal(false)}
        footer={null}
        title="Ask Commercial"
        destroyOnClose
        width={1100}
      >
        <AskInfluencerCommercials
          briefInfluencer={briefInfluencer}
          onClose={() => setIsCommercialsRequestedModal(false)}
        />
      </Modal> */}
    </>
  );
}
